//复议基本信息
const reconsiderBasic = () => import('../views/applyReconsider/reconsiderBasic')
//申请复议
const applyReconsider = () => import('../views/applyReconsider/reconsider-info/index.vue')
//复议详情
const reconsiderDetail = () => import('../views/applyReconsider/reconsider-detail/index.vue')
export default [
    {
        path: '/reconsiderBasic',
        name: 'reconsiderBasic',
        component: reconsiderBasic,
        meta: {
            title: '保全-填写复议信息'
        },
    },
    {
        path: '/applyReconsider',
        name: 'applyReconsider',
        component: applyReconsider,
        meta: {
            title: '保全-申请复议'
        }
    },
    {
        path: '/reconsiderDetail',
        name: 'reconsiderDetail',
        component: reconsiderDetail,
        meta: {
            title: '保全-复议详情'
        }
    }
]
